import React from "react";
import { ControlLabel, Button, Alert } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import PageListItem from "./page-list-item.jsx";

export default class PageList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sortBy: 'creationDate',
            sortDirection: 'asc'
        }

        this.onTableHeaderClick = this.onTableHeaderClick.bind(this);
    }

    onTableHeaderClick(event) {
        var id = event.target.id;
        var direction = 'asc';

        if (this.state.sortBy == id) {
            if (this.state.sortDirection == 'asc') {
                direction = 'desc';
            }
            else {
                direction = 'asc';
            }
        }

        this.setState({
            sortBy: id,
            sortDirection: direction
        });

        function compare(value1, value2) {
            if (value1 < value2)
                return -1;
            if (value1 > value2)
                return 1;
            return 0;
        }

        if (direction == 'asc') {
            switch (id) {
                case 'id': 
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj1.id, obj2.id);
                    });
                    break;
                case 'pageName':
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj1.pageName, obj2.pageName);
                    });
                    break;
                case 'systemPage':
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj1.canDelete, obj2.canDelete);
                    });
                    break;
                case 'createdDate':
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj1.creationDate, obj2.creationDate);
                    });
                    break;
                case 'createdBy':
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj1.creationOperator, obj2.creationOperator);
                    });
                    break;
                case 'modifiedDate':
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj1.modifyDate, obj2.modifyDate);
                    });
                    break;
                case 'modifiedBy':
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj1.modifyOperator, obj2.modifyOperator);
                    });
                    break;
            }
        }
        else {
            switch (id) {
                case 'id': 
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj2.id, obj1.id);
                    });
                    break;
                case 'pageName':
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj2.pageName, obj1.pageName);
                    });
                    break;
                case 'systemPage':
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj2.canDelete, obj1.canDelete);
                    });
                    break;
                case 'createdDate':
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj2.creationDate, obj1.creationDate);
                    });
                    break;
                case 'createdBy':
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj2.creationOperator, obj1.creationOperator);
                    });
                    break;
                case 'modifiedDate':
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj2.modifyDate, obj1.modifyDate);
                    });
                    break;
                case 'modifiedBy':
                    this.props.pages.sort(function(obj1, obj2) { 
                        return compare(obj2.modifyOperator, obj1.modifyOperator);
                    });
                    break;
            }
        }

        if (this.props.onChange) {
            this.props.onChange(this.props.pages);
        }
    }

    render() {
        var items = [];

        if (this.props.pages.length > 0) {
            for (var i = 0; i < this.props.pages.length; i++) {
                let dataItem = this.props.pages[i];
                items.push(
                    <PageListItem vm={dataItem} noLabel={this.props.noLabel} yesLabel={this.props.yesLabel}></PageListItem>
                );
            }
        }

        return (
            <div className={this.props.pages.length > 0 ? "" : "ap-hidden"}>
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <td onClick={this.onTableHeaderClick} id="id">ID</td>
                                    <td onClick={this.onTableHeaderClick} id="pageName">Page Name</td>
                                    <td onClick={this.onTableHeaderClick} id="systemPage">System Page</td>
                                    <td onClick={this.onTableHeaderClick} id="createdDate">Created Date</td>
                                    <td onClick={this.onTableHeaderClick} id="createdBy">Created By</td>
                                    <td onClick={this.onTableHeaderClick} id="modifiedDate">Modified Date</td>
                                    <td onClick={this.onTableHeaderClick} id="modifiedBy">Modified By</td>
                                </tr>
                            </thead>
                            <tbody>
                                {items}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}